var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectora({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62558 0.208496C5.73812 0.208496 3.92797 0.958285 2.59334 2.29292C1.2587 3.62755 0.508911 5.43771 0.508911 7.32516V35.7918H7.62558V21.5585H14.7422V35.7918H21.8589V7.32516C21.8589 5.43771 21.1091 3.62755 19.7745 2.29292C18.4399 0.958285 16.6297 0.208496 14.7422 0.208496H7.62558ZM7.62558 7.32516H14.7422V14.4418H7.62558V7.32516Z",
    fill: "#33697A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectora);
export default __webpack_public_path__ + "static/media/Vectora.03c8dd7a6f90445e6dfd145ab30c84ed.svg";
export { ForwardRef as ReactComponent };